import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { isFullBleedPath } from './fullBleedRoutes'
import Navigation from './Navigation'

const Layout: React.FC = () => {
  const { pathname } = useLocation()
  const fullBleed = isFullBleedPath(pathname)
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <main className={fullBleed ? 'w-full' : 'mx-auto max-w-5xl px-4 py-6'}>
        <Outlet />
      </main>
    </div>
  )
}

export default Layout
